import { Breakpoint, styled } from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import PaneRow from "../models/PaneRow";
import { AccessLevel } from "./AccessLevel";

interface ConfigProperties {
  alternateText: string;
  dataId: string;
  imageHeight: { [key in Breakpoint]: number | undefined };
  imageSizing: "Fit to Size" | "Mask to Size";
  imageUrl: string;
  imageWidth: { [key in Breakpoint]: number | undefined };
  name: string;
}

interface RuntimeProperties {
  accessLevel: AccessLevel;
}

interface BrandingImageProps {
  imageHeight: { [key in Breakpoint]: number | undefined };
  imageSizing: "Fit to Size" | "Mask to Size";
  imageWidth: { [key in Breakpoint]: number | undefined };
}

const BrandingImage = styled("img")<BrandingImageProps>(
  ({ imageSizing }) => ({
    display: "block",
    height: imageSizing === "Mask to Size" ? "100%" : undefined,
    objectFit: imageSizing === "Fit to Size" ? "contain" : "none",
    width: imageSizing === "Mask to Size" ? "100%" : undefined,
  }),
  ({ imageHeight, imageWidth, theme }) =>
    theme.breakpoints.keys.reduce((result, breakpoint) => {
      result[theme.breakpoints.only(breakpoint)] = {
        maxHeight: imageHeight[breakpoint],
        maxWidth: imageWidth[breakpoint],
      };

      if (imageHeight[breakpoint] && imageWidth[breakpoint]) {
        result[theme.breakpoints.only(breakpoint)] = {
          ...result[theme.breakpoints.only(breakpoint)],
          height: imageHeight[breakpoint],
          width: imageWidth[breakpoint],
        };
      }

      return result;
    }, {} as { [key: string]: React.CSSProperties })
);

export const BrandingImageRasterDisplay = observer(
  (props: ConfigProperties): JSX.Element | null => {
    const row = PaneRow.get(props.dataId);
    if (!row) {
      return null;
    }

    const widget = row.getWidgetT<null, RuntimeProperties>(props.name);
    if (widget.properties.accessLevel === AccessLevel.hidden) {
      return null;
    }

    return (
      <BrandingImage
        aria-hidden={!props.alternateText || undefined}
        aria-label={props.alternateText || undefined}
        imageHeight={props.imageHeight}
        imageSizing={props.imageSizing}
        imageWidth={props.imageWidth}
        src={props.imageUrl}
      />
    );
  }
);
